var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "rgba(255, 255, 255, 0.6)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162 1048 c-22 -22 -13 -52 30 -95 l42 -43 -24 -17 c-90 -62 -210 -207 -210 -253 0 -33 66 -125 136 -190 94 -87 190 -143 314 -181 62 -20 95 -24 195 -23 81 1 136 7 170 17 l50 17 65 -65 c65 -64 94 -77 118 -53 35 35 21 52 -409 477 -246 243 -430 417 -443 419 -12 2 -27 -3 -34 -10z m308 -419 c0 -85 74 -159 159 -159 41 0 52 -5 85 -39 l39 -40 -44 -11 c-194 -53 -382 135 -329 329 l11 44 40 -39 c34 -33 39 -44 39 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 1030 c-28 -5 -64 -14 -80 -20 l-28 -11 55 -55 55 -55 48 12 c195 49 376 -132 327 -327 l-12 -48 79 -79 79 -79 64 54 c72 61 157 161 166 196 9 37 -4 65 -65 137 -104 125 -230 209 -377 255 -80 24 -232 34 -311 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705 710 c55 -55 101 -100 102 -100 2 0 3 20 3 44 0 82 -75 156 -159 156 l-46 0 100 -100z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePass);
export default __webpack_public_path__ + "static/media/hide-pass.ef755315f7b2ab10f2f34e49720aff21.svg";
export { ForwardRef as ReactComponent };